import React from 'react';
import isNil from 'lodash/isNil';
import { assertCondition } from '../../../utils/types';
import { useChartContext } from '../ChartContext';
import { QueryType } from '../../../utils/apollo/graphqlSchema';
import ErrorChartInfo from '../ErrorChartInfo';
import SignificanceChartTestInfo from './SignificanceChartTestInfo';
import SignificanceTable from './SignificanceTable';
import SignificancePerformanceChart from './SignificancePerformanceChart';
import styled from 'styled-components';
import { ChartMode, ChartViewType } from '../types';

interface IProps {
  analysisId: string;
  mode: ChartMode;
}

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

const SignificanceChart = ({ analysisId, mode }: IProps) => {
  const {
    chartData,
    metadata: { query },
  } = useChartContext();
  assertCondition(
    !isNil(query) &&
      query.__typename === 'SignificanceQuery' &&
      chartData.queryType === QueryType.Significance &&
      !isNil(chartData?.data),
  );

  const { data } = chartData;
  const metricTypeKey = query.metricType.key;

  const isCompactMode = mode === ChartMode.Compact;

  return (
    <Container>
      {!isCompactMode && (
        <>
          <SignificanceChartTestInfo builderInfo={query} />
          <SignificanceTable data={data} metricTypeKey={metricTypeKey} />
        </>
      )}
      {data?.error ? (
        <ErrorChartInfo type={ChartViewType.CustomError} title={data.error} />
      ) : (
        <SignificancePerformanceChart
          data={data}
          analysisId={analysisId}
          mode={mode}
        />
      )}
    </Container>
  );
};

export default SignificanceChart;
